import { AdminCargoCreatePage } from "@/pages/admin-cargo-create";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/admin/cargos/create")({
  component: () => <AdminCargoCreatePage />,
});
